import { render, staticRenderFns } from "./TutorTask.vue?vue&type=template&id=39f6de06&scoped=true&"
import script from "./TutorTask.vue?vue&type=script&lang=js&"
export * from "./TutorTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f6de06",
  null
  
)

export default component.exports